import { useMemo } from 'react';
import { getPeriodsOptions } from '../logic/constants';

export default function usePeriodOptions() {
	const periodOptions = useMemo(() => 
		getPeriodsOptions(),
	[]);
	return periodOptions;
}
